import {
  EmployeeProductivityResponse,
} from '../../types/Employee/employeeProductivity.types';

export const employeeProductivityMock: EmployeeProductivityResponse = {
  summaryCards: [
    {
      id: 1,
      title: "Today's Productivity",
      value: '84%',
      subtitle: '+3pp vs 80% target',
      icon: 'Zap',
      iconBg: '#E8F8F0',
      iconColor: '#18A957',
    },
    {
      id: 2,
      title: 'Monthly Avg',
      value: '81%',
      subtitle: 'May 2026 to date',
      icon: 'BarChart3',
      iconBg: '#EAF3FF',
      iconColor: '#3B82F6',
    },
    {
      id: 3,
      title: 'Productive Time',
      value: '6h 02m',
      subtitle: 'Of 7h 12m active',
      icon: 'Clock3',
      iconBg: '#F3E8FF',
      iconColor: '#7C3AED',
    },
    {
      id: 4,
      title: 'Non-Prod Time',
      value: '22 min',
      subtitle: 'YouTube, Social · Today',
      icon: 'CircleOff',
      iconBg: '#FFF3E8',
      iconColor: '#F97316',
    },
    {
      id: 5,
      title: 'Team Rank',
      value: '3 / 11',
      subtitle: 'Top 30% in team',
      icon: 'Users',
      iconBg: '#FCE7F3',
      iconColor: '#DB2777',
    },
  ],

  hourlyProductivity: [
    {
      time: '09',
      productive: 84,
      nonProductive: 0,
      neutral: 16,
      target: 80,
    },
    {
      time: '09:30',
      productive: 0,
      nonProductive: 0,
      neutral: 100,
      target: 80,
    },
    {
      time: '10:30',
      productive: 91,
      nonProductive: 0,
      neutral: 9,
      target: 80,
    },
    {
      time: '11',
      productive: 95,
      nonProductive: 0,
      neutral: 5,
      target: 80,
    },
    {
      time: '11:30',
      productive: 92,
      nonProductive: 0,
      neutral: 8,
      target: 80,
    },
    {
      time: '12',
      productive: 0,
      nonProductive: 0,
      neutral: 100,
      target: 80,
    },
    {
      time: '13:30',
      productive: 0,
      nonProductive: 0,
      neutral: 100,
      target: 80,
    },
    {
      time: '14',
      productive: 93,
      nonProductive: 4,
      neutral: 3,
      target: 80,
    },
    {
      time: '14:30',
      productive: 89,
      nonProductive: 5,
      neutral: 6,
      target: 80,
    },
    {
      time: '15',
      productive: 86,
      nonProductive: 0,
      neutral: 14,
      target: 80,
    },
    {
      time: '15:45',
      productive: 84,
      nonProductive: 0,
      neutral: 16,
      target: 80,
    },
    {
      time: '16',
      productive: 82,
      nonProductive: 8,
      neutral: 10,
      target: 80,
    },
    {
      time: '16:30',
      productive: 80,
      nonProductive: 10,
      neutral: 10,
      target: 80,
    },
  ],

  timeClassification: [
    {
      name: 'Productive',
      value: 84,
      color: '#22C55E',
    },
    {
      name: 'Non-Productive',
      value: 5,
      color: '#EF4444',
    },
    {
      name: 'Neutral',
      value: 11,
      color: '#94A3B8',
    },
  ],

  productivityTrend: [
  {
    day: 'Mon',
    productivity: 78,
    target: 80,
  },
  {
    day: 'Tue',
    productivity: 82,
    target: 80,
  },
  {
    day: 'Wed',
    productivity: 84,
    target: 80,
  },
  {
    day: 'Thu',
    productivity: 81,
    target: 80,
  },
  {
    day: 'Fri',
    productivity: 86,
    target: 80,
  },
],

meVsTeam: [
  {
    day: 'Mon 29',
    me: 84,
    team: 82,
    target: 80,
  },
  {
    day: 'Tue 28',
    me: 81,
    team: 79,
    target: 80,
  },
  {
    day: 'Wed 27',
    me: 87,
    team: 83,
    target: 80,
  },
  {
    day: 'Thu 26',
    me: 78,
    team: 77,
    target: 80,
  },
  {
    day: 'Fri 25',
    me: 90,
    team: 84,
    target: 80,
  },
],

applicationDetails: [
  {
    id: 1,
    application: 'Epic',
    time: '3h 05m',
    percentage: 42,
    classification: 'Productive',
    category: 'Clinical',
  },
  {
    id: 2,
    application: 'Citrix',
    time: '2h 04m',
    percentage: 28,
    classification: 'Productive',
    category: 'Workspace',
  },
  {
    id: 3,
    application: 'Outlook',
    time: '1h 18m',
    percentage: 18,
    classification: 'Neutral',
    category: 'Communication',
  },
  {
    id: 4,
    application: 'YouTube',
    time: '14m',
    percentage: 3,
    classification: 'Non-Prod',
    category: 'Entertainment',
  },
  {
    id: 5,
    application: 'Chrome',
    time: '31m',
    percentage: 9,
    classification: 'Neutral',
    category: 'Browser',
  },
],

monthlyProductivityTrend: [
  {
    day: '1',
    productivity: 72,
  },
  {
    day: '5',
    productivity: 79,
  },
  {
    day: '10',
    productivity: 84,
  },
  {
    day: '15',
    productivity: 81,
  },
  {
    day: '20',
    productivity: 87,
  },
  {
    day: '25',
    productivity: 91,
  },
  {
    day: '30',
    productivity: 89,
  },
],

};